import {
  GET_CHECK_IN_REQUEST,
  GET_CHECK_IN_SUCCESS,
  GET_CHECK_IN_FAIL,
} from "../../types/admin/checkInTypes";

export const getCheckInReducer = (state = { notifications: [] }, action) => {
  switch (action.type) {
    case GET_CHECK_IN_REQUEST:
      return { loading: true, notifications: [] };

    case GET_CHECK_IN_SUCCESS:
      return {
        loading: false,
        notifications: action.payload?.userCheckIn || [],
      };

    case GET_CHECK_IN_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
